export class CreateApplicationProfessionalBodiesEcConstants {
    static STEP_TITLE = "Professional bodies";
    static PROFESSIONAL_BODY_FORM_CONTROL_NAME = "professionalBodiesForm";
    static COMPONENT_NAME = "professional-bodies";
    static MARK_ARCHITECT_AS_REQUIRED_LABEL = "Are the architect's details required?";
    static MARK_ARCHITECT_AS_REQUIRED_FORM_CONTROL_NAME = "markArchitectAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ARCHITECT_LABEL = "Copy applicant details to architect?";
    static COPY_APPLICANT_DETAILS_TO_ARCHITECT_FORM_CONTROL_NAME = "copyApplicantToArchitect";
    static MARK_ENGINEER_REQUIRED_LABEL = "Electrical engineer's details";
    static MARK_ENGINEER_AS_REQUIRED_FORM_CONTROL_NAME = "markElectricalEngineerAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL = "Copy applicant details to electrical engineer?";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME = "copyApplicantToElectricalEngineer";
    static MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_LABEL = "Electrical contractor's details";
    static MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_FORM_CONTROL_NAME = "markElectricalContractorAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL = "Copy applicant details to electrical contractor?";
    static COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME = "copyApplicantToContractor";
    static ARCHITECT_LABEL = "Architect";
    static ENGINEER_LABEL = "Electrical engineer";
    static ELECTRICAL_CONTRACTOR_LABEL = "Electrical contractor";
    static ARCHITECT_FORM_CONTROL_NAME = "architectRecipient";
    static ENGINEER_FORM_CONTROL_NAME = "electricalEngineerRecipients";
    static ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME = "electricalContractorRecipient";
}
